/* ============================================================
   VELA MAREN — Wishlist (localStorage, no app required)
   Handles: add/remove, heart sync, count badge
   ============================================================ */
(function () {
  var KEY = 'vela_wishlist';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); }
    catch (e) {}
  }

  function has(handle) {
    return get().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = get();
    var idx  = list.indexOf(handle);
    if (idx === -1) { list.push(handle); }
    else            { list.splice(idx, 1); }
    save(list);
    return idx === -1; /* true = just added */
  }

  function syncHearts() {
    var list = get();
    document.querySelectorAll('[data-wl-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-saved', list.indexOf(btn.dataset.wlToggle) !== -1);
    });
  }

  function updateCountBadge() {
    var count = get().length;
    document.querySelectorAll('[data-wl-count]').forEach(function (el) {
      el.textContent = count || '';
      el.classList.toggle('is-visible', count > 0);
    });
  }

  /* Delegated click — works for dynamically rendered cards too */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wl-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.dataset.wlToggle;
    var added  = toggle(handle);
    btn.classList.toggle('is-saved', added);
    btn.classList.add('is-pulse');
    setTimeout(function () { btn.classList.remove('is-pulse'); }, 420);
    updateCountBadge();
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncHearts();
    updateCountBadge();
  });

  /* Public API used by wishlist page */
  window.VelaWishlist = { get: get, has: has, toggle: toggle };
})();
